import React from "react";
import { Drawer } from "antd";
import ExerciseBar from "../../../ExerciseBar";
import style from "./index.module.scss";
import { TopicsItem } from "../../../../../../../API/exercise";

interface AnswerCardDrawerProps {
    visible: boolean;
    onClose: () => void;
    checked: number;
    data: TopicsItem[];
    onChange: (val: number) => void;
}

export default function AnswerCardDrawer({
    visible,
    onClose,
    checked,
    data,
    onChange
}: AnswerCardDrawerProps) {
    function barChange(num: number) {
        onChange(num);
        onClose();
    }

    function close() {
        onClose();
    }

    return (
        <Drawer
            placement="right"
            closable={false}
            onClose={onClose}
            visible={visible}
            getContainer={false}
            maskClosable
            className={style.root}>
            {/*全部试题是否正确列表判断*/}
            <ExerciseBar
                checked={checked}
                data={data}
                onChange={barChange}
                onClose={close}
            />
        </Drawer>
    );
}
